import { render, staticRenderFns } from "./PopupList.vue?vue&type=template&id=8f1b4e14&scoped=true"
import script from "./PopupList.vue?vue&type=script&lang=js"
export * from "./PopupList.vue?vue&type=script&lang=js"
import style0 from "./PopupList.vue?vue&type=style&index=0&id=8f1b4e14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1b4e14",
  null
  
)

export default component.exports